const getPfasAtlasColumnGroups = () => [
  {
    id: 'category',
    name: 'Category',
    hideInSelect: true,
  },
]

export { getPfasAtlasColumnGroups }
